import { useStyles } from "./Leaderboard.style";
import {
  Header,
  Icon,
  Typography,
  TypographyVariant,
  useCustomNavigate,
} from "@onmo/ui";
import { TabsList } from "../../components/core/TabsList";
import { useEffect, useState } from "react";
import { GlobalLeaderboardType } from "@onmo/graphql/graphql";
import { globalLeaderboardsGQL, meGQL } from "../../graphql";
import { useQuery } from "@apollo/client";
import { countDownDate } from "../../models/time";
import { HowToWinTab } from "../../components/common/HowToWinTab";
import LeaderboardUsers from "../../components/common/LeaderboardUsers/LeaderboardUsers";
import { LeaderboardType } from "../../constants/user";
import { useTranslation } from "react-i18next";

const Leaderboard: React.FC = () => {
  const classes = useStyles();
  const { t } = useTranslation();
  const { handleBack } = useCustomNavigate();
  const [activeTab, setActiveTab] = useState({
    tab: GlobalLeaderboardType.Daily,
    title: "Today",
  });
  const [mountedTab, setMountedTab] = useState<
    Array<(typeof listTabs)[number]>
  >([]);
  const listTabs = ["How to win", "Today", "Weekly", "Monthly"];
  const { data: dataMe } = useQuery(meGQL);
  const { data, fetchMore, refetch, loading, networkStatus } = useQuery(
    globalLeaderboardsGQL,
    {
      variables: {
        input: {
          globalLeaderboardType: activeTab.tab,
        },
      },
      notifyOnNetworkStatusChange: true,
    },
  );

  const onChangeTab = (tab: string) => {
    if (tab === "Today")
      setActiveTab({ tab: GlobalLeaderboardType.Daily, title: "Today" });
    else if (tab === "Weekly")
      setActiveTab({ tab: GlobalLeaderboardType.Weekly, title: "Weekly" });
    else if (tab === "Monthly")
      setActiveTab({ tab: GlobalLeaderboardType.Monthly, title: "Monthly" });
    else
      setActiveTab({ tab: GlobalLeaderboardType.Daily, title: "How to win" });
  };

  const loadMoreUser = () => {
    if (
      data.leaderboard.items.length >= 200 ||
      data.leaderboard.items.length === data.leaderboard.total
    )
      return;

    fetchMore({
      variables: {
        input: {
          globalLeaderboardType: activeTab.tab,
          page: {
            limit: 20,
            offset: data?.leaderboard?.items?.length,
          },
        },
      },
    });
  };

  const renderTabContent = () => {
    const globalLeaderboards = data?.leaderboard;
    if (activeTab.title === "How to win") {
      return (
        <HowToWinTab
          className={classes.howToWin}
          rank={data?.leaderboard?.rank}
          username={t("me")}
          score={data?.leaderboard?.score}
          avatar={dataMe?.me.avatar}
        />
      );
    }
    return (
      <>
        <div className={classes.endTime}>
          <Typography variant={TypographyVariant.BodyB4Regular}>
            {t("ends_in")}
          </Typography>
          {globalLeaderboards?.endDate && (
            <Typography variant={TypographyVariant.BodyB5Regular}>
              <Icon name="icon-timer" className={classes.iconTimer} size={14} />
              {countDownDate(globalLeaderboards?.endDate)}
            </Typography>
          )}
        </div>
        <LeaderboardUsers
          loading={loading || networkStatus === 4}
          leaderboards={globalLeaderboards}
          loadMoreUser={loadMoreUser}
          type={activeTab.tab as LeaderboardType}
        />
      </>
    );
  };
  useEffect(() => {
    if (!mountedTab.includes(activeTab.title)) {
      if (mountedTab.length > 0) refetch();
      setMountedTab([...mountedTab, activeTab.title]);
      return;
    }
  }, [activeTab, mountedTab, refetch]);
  return (
    <div className={classes.root}>
      <Header
        title={t("leaderboard")}
        leftElement={
          <Icon
            name="icon-bold-arrow-left-3"
            onClick={() => {
              handleBack();
            }}
          />
        }
      />
      <div className={classes.content}>
        <TabsList
          listTabs={listTabs}
          onChangeTab={onChangeTab}
          activeTab={activeTab.title}
        />
        {renderTabContent()}
      </div>
    </div>
  );
};
export default Leaderboard;
